// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__19jX3","sendOtp":"AuthorizeToLogin_sendOtp__2Vea7"};